import React from 'react';
import { BASE_URL } from '../../config';
import { SliderWrapper, SliderSlide } from './Slider.styles';

// Styles
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const Slider = ({ data }) => {
  const { content } = data[0];

  const sliderImages =
    content.length > 0 && content[0].hasOwnProperty('multiSRC')
      ? content[0].multiSRC
      : null;

  const sliderSettings = {
    dots: false,
    infinite: true,
    autoplay: true,
    speed: 5000,
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <SliderWrapper {...sliderSettings}>
      {sliderImages.map((slide, index) => (
        <SliderSlide key={index} src={`${BASE_URL}${slide.img.src}`} />
      ))}
    </SliderWrapper>
  );
};

export default Slider;
